import { useCallback } from 'react';

import { useAuthStore } from '../store';

export const usePermissions = () => {
    const { permissions } = useAuthStore();

    const hasPermission = useCallback(
        (permissionName: string) => {
            return permissions.some((per) => per.name === permissionName);
        },
        [permissions]
    );

    return hasPermission;
};
